import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import { Colors } from '../../assets/styles';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    '& ul': {
      padding: 0,
    },
  },
  input: {
    width: 200,
  },
  applyFilterBtn: {
    color: Colors.Green,
  },
}));

export default useStyles;
